// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // Check if token is present
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // If no token, redirect to login
    return <Navigate to="/admin/login" replace />;

  }

  // Else, render child component
  return children;
}

export default ProtectedRoute;
